import axios from "axios";
// const baseURL =
//   process.env.REACT_APP_BASE_API_URL || "https://api.neogamerz.com";
const baseURL = "https://api-staging.neogamerz.com";

const buildUrl = (endPoint, params) => {
  const cleanedEndpoint = String(endPoint || "").replace(/^\/+|\/+$/g, "");
  if (params === undefined || params === null || params === "") {
    return `${baseURL}/${cleanedEndpoint}`;
  }
  const cleanedParams = String(params).replace(/^\/+|\/+$/g, "");
  return `${baseURL}/${cleanedEndpoint}/${cleanedParams}`;
};

const postRequest = async ({ body, query, params, endPoint, token }) => {
  return await axios.post(buildUrl(endPoint, params), body, {
    params: query,
    headers: {
      ...(token ? { Authorization: token ? `Bearer ${token}` : undefined } : {}),
      "Content-Type": "application/json",
    },
  });
};

const getRequest = async ({ query, params, endPoint, token }) => {
  return await axios.get(buildUrl(endPoint, params), {
    params: query,
    headers: {
      ...(token ? { Authorization: token ? `Bearer ${token}` : undefined } : {}),
      "Content-Type": "application/json",
      "accept-language": localStorage?.getItem("lng") || "en",
    },
  });
};

const delRequest = async ({ query, params, endPoint, token }) => {
  return await axios.delete(buildUrl(endPoint, params), {
    params: query,
    headers: {
      ...(token ? { Authorization: token ? `Bearer ${token}` : undefined } : {}),
      "Content-Type": "application/json",
    },
  });
};

const putRequest = async ({ body, query, params, endPoint, token }) => {
  return await axios.put(buildUrl(endPoint, params), body, {
    params: query,
    headers: {
      ...(token ? { Authorization: token ? `Bearer ${token}` : undefined } : {}),
      "Content-Type": "application/json",
    },
  });
};

const patchRequest = async ({ body, query, params, endPoint, token }) => {
  return await axios.patch(buildUrl(endPoint, params), body, {
    params: query,
    headers: {
      ...(token ? { Authorization: token ? `Bearer ${token}` : undefined } : {}),
      "Content-Type": "application/json",
    },
  });
};

export { baseURL, delRequest, getRequest, patchRequest, postRequest, putRequest };

